import { useTranslation } from 'react-i18next';

import styles from './InterfaceSettings.module.css';

/**
 * A small Kanban column in the same scale scope as the real board: it is built from the same
 * tokens, so it grows and shrinks exactly like the board does.
 */
export function ScalePreview() {
  const { t } = useTranslation();
  return (
    <div className={styles.preview} data-scale-scope="kanban" data-testid="scale-preview">
      <div className={styles.previewColumn}>
        <header className={styles.previewHeader}>
          <strong>{t('interfaceSettings.sampleColumn')}</strong>
          <span className={styles.previewBadge}>2</span>
        </header>
        <div className={styles.previewCard}>{t('interfaceSettings.sampleCardOne')}</div>
        <div className={styles.previewCard}>{t('interfaceSettings.sampleCardTwo')}</div>
      </div>
    </div>
  );
}
